import { render, staticRenderFns } from "./Dwdcblr.vue?vue&type=template&id=37ae9bcb"
import script from "./Dwdcblr.vue?vue&type=script&lang=js"
export * from "./Dwdcblr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports